//export const SERVER = "http://localhost:9080/psd";
//export const WS_SERVER = 'ws://localhost:9080/psd/psdservicews';

//export const SERVER = "http://u.triggybet.com/psd";
//export const WS_SERVER = 'ws://u.triggybet.com/psd/psdservicews';

export const SERVER = "http://134.209.230.231:8080";
export const IMAGE_SERVER = "http://134.209.230.231/img";
//export const SERVER = "https://cors-anywhere.herokuapp.com/" + NOCORS_SERVER;
export const WS_SERVER = 'ws://u.triggybet.com/psd/psdservicews';

export const EVENT_TYPE_RESULT = 4;
export const EVENT_TYPE_STROKE = 3;
export const EVENT_TYPE_HIT = 2;
export const EVENT_TYPE_PREPARE_HIT = 1;

export const LEADERBOARD_ID = 101; //test leaderboard used in HoleItem
export const LEADERBOARD_GSS_ID = 1228;






// WEBPACK FOOTER //
// ./src/Common/constants.js